/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const modalCss = {
  // background: colorsPalette.white,
};

export const fullvideosec = css({
  backgroundColor: '#f4f3f0',

  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
  width: 'calc(100% - 130px)',
  maxWidth: '1440px',
  margin: '96px auto 0px auto',
  [MediaQueries.sm]: {
    margin: '0px 0px 0px 0px',
    width: '100%',
    overflow: 'hidden',
  },

  [MediaQueries.md]: {
    margin: '64px 0px 0px 0px',
    width: '100%',
  },
  [MediaQueries.lg]: {
    margin: '64px 0px 0px 0px',
    width: '100%',
  },

  '.video_sec': {
    display: 'flex',
    display: '-webkit-box',
    alignItems: 'center',
    cursor: 'pointer',
    [MediaQueries.sm]: {
      height: '500px',
    },
    [MediaQueries.md]: {
      height: '500px',
    },

    '.video_txt': {
      position: 'relative',
      right: '25%',
      bottom: '15px',
      whiteSpace: 'nowrap',
      fontWeight: 700,
      fontSize: '21px',

      [MediaQueries.sm]: {
        display: 'none',
      },
    },
  },
  '.video-thumb': {
    width: '100%',
    [MediaQueries.lg]: {},
    [MediaQueries.md]: {
      paddingBottom: '10px',
      objectFit: 'cover',
      height: '389px',
    },
    [MediaQueries.sm]: {
      paddingBottom: '10px',
      objectFit: 'cover',
      height: '478px',
    },
  },

  '.play_icon': {
    transition: '0.5s ease',
    position: 'absolute',
    top: '50%',
    cursor: 'pointer',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    msTransform: 'translate(-50%, -50%)',
    textAlign: 'center',

    img: {
      [MediaQueries.lg]: {
        maxWidth: '45px',
      },
      [MediaQueries.md]: {
        maxWidth: '45px',
      },
      [MediaQueries.sm]: {
        maxWidth: '45px',
      },
    },

    '.play_btn': {
      fontSize: '12px',
      lineHeight: '20px',
      letterSpacing: '0.800000011920929px',
      fontWeight: '500',
      textAlign: 'center',
    },
  },
});
export const customContainer = css({
  [MediaQueries.sm]: {
    width: '100%',
  },
});
